const actionTypes = { SET_SERVICES_AND_EVENTS: 'SET_SERVICES_AND_EVENTS' };

module.exports = actionTypes;
